import { render } from "./Emission.vue?vue&type=template&id=067d83c1&scoped=true"
import script from "./Emission.vue?vue&type=script&lang=js"
export * from "./Emission.vue?vue&type=script&lang=js"

import "./Emission.vue?vue&type=style&index=0&id=067d83c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067d83c1"]])

export default __exports__